import axios, { AxiosResponse } from 'axios';
import { message } from 'antd';
import constants from 'src/constants/index';
import { BusinessError } from 'src/utils/business-error';
import { h } from 'src/utils/h';
import i18n from 'i18next';
import { getTokenData } from './localStorage';

const service = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 180000,
});

// Request interceptors
service.interceptors.request.use(
  config => {
    let tokenData: any = null;
    try {
      const rawData = getTokenData();
      if (rawData && rawData !== 'undefined') {
        tokenData = JSON.parse(rawData);
      }
    } catch (e) {
      console.error('Error parsing tokenData in request', e);
    }
    const eworkTokenData = encodeURIComponent(
      localStorage.getItem('eworkTokenData') ?? '',
    );
    if (tokenData !== null) {
      if (config.headers) {
        config.headers['eworkTokenData'] = eworkTokenData;
        config.headers['Authorization'] =
          'Bearer ' + tokenData.id_token;
        config.headers['SessionId'] = tokenData.sessionId;
        config.headers['X-Frame-Options'] = 'DENY';
        config.headers['content-type'] = 'application/json';
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

// Response interceptors
service.interceptors.response.use(
  response => {
    const res = response.data;
    const responseStatus = response.status;
    if (responseStatus < 200 || responseStatus >= 300) {
      return Promise.reject(
        new Error(res.message || 'Error'),
      );
    } else {
      return response;
    }
  },
  async error => {
    if (error.response) {
      const error_ = error.response as AxiosResponse;
      if (
        error_.status ===
        constants.AXIOS.HTTP_STATUS.BAD_REQUEST &&
        error_.data &&
        error_.data.message === 'businessError'
      ) {
        const businessErrors: BusinessError[] = JSON.parse(
          error_.data.errors,
        );
        if (businessErrors && businessErrors.length) {
          h.each(businessErrors, businessError => {
            message.error(
              i18n
                .t(`error.${businessError.errorCode}`)
                .toString(),
              constants.MESSAGE_DURATION,
            );
          });
          return Promise.reject(error);
        }
      } else if (
        error_.status ===
        constants.AXIOS.HTTP_STATUS.UNAUTHORIZED
      ) {
        const loginUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL + '/login' : '/login';
        if (window.location.pathname !== loginUrl) {
          localStorage.clear();
          window.location.href = loginUrl;
        }
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

export default service;
